<div id="agreement_container">
  <section class="nes-mb-5">
    <nes-heading tag="h1" size="8xl" [cypress]="'page_title'" class="nes-mb-1">
      {{ "AGREEMENT.TITLE" | translate }}
    </nes-heading>
    <nes-text class="nes-mb-8" size="sm">
      {{ "REQUIRED_FIELD" | translate }}
    </nes-text>
    <nes-heading tag="h2" size="2xl">{{
      "AGREEMENT.SUB_TITLE" | translate
    }}</nes-heading>
  </section>

  <section class="nes-mb-10">
    <div class="formfield">
      <div class="nes-mb-5">
        <div class="nes-flex nes-items-center">
          <input
            type="checkbox"
            class="nes-h-6 nes-w-6 nes-mr-5"
            name="Name here"
            [formControl]="
              getControl('authorizedAgreementAndProductConditions')
            "
            (click)="
              onCheckboxClick($event, 'authorizedAgreementAndProductConditions')
            "
            indeterminate="false"
            borderless="false"
            id="authorizedAgreementAndProductConditions"
          />
          <label for="authorizedAgreementAndProductConditions">
            <nes-text size="lg">
              {{ "AGREEMENT.INPUT.AUTHORIZE_AGREEMENT.LABEL" | translate }}
            </nes-text>
          </label>
        </div>
        @if (getAuthorizedAgreementErrorKey()) {
          <nes-error-message>
            {{ getAuthorizedAgreementErrorKey() }}
          </nes-error-message>
        }
      </div>
      <div class="terms">
        <span>
          <a stand-alone (click)="showAgreement(AgreementType.PREVIEW)">
            {{
              "AGREEMENT.INPUT.AUTHORIZE_AGREEMENT.AGREEMENT.NSBC" | translate
            }}
          </a>
        </span>
        <span class="file-size">(pdf, 441 kb)</span> ,&nbsp;
        <span>
          <a stand-alone (click)="showAgreement(AgreementType.PRODUCT)">
            {{
              "AGREEMENT.INPUT.AUTHORIZE_AGREEMENT.AGREEMENT.PRODUCT"
                | translate
            }}
          </a> </span
        ><span class="file-size">(pdf, 181 kb)</span> ,&nbsp;
        <span>
          <a stand-alone (click)="showAgreement(AgreementType.TRANSPORT)">
            {{
              "AGREEMENT.INPUT.AUTHORIZE_AGREEMENT.AGREEMENT.TRANSPORT_AND_LUGGAGE"
                | translate
            }}
          </a>
          <span class="file-size">(pdf, 164 kb)</span> ,&nbsp;
        </span>
        <span>
          <a stand-alone (click)="showAgreement(AgreementType.BTM)">
            {{
              "AGREEMENT.INPUT.AUTHORIZE_AGREEMENT.AGREEMENT.URBAN_REGIONAL_PUBLIC_TRANSPORT"
                | translate
            }}
          </a>
          <span class="file-size">(pdf, 187 kb)</span>
        </span>
        <span *ngIf="hasSelectedBikeAsService$ | async">
          {{
            "AGREEMENT.INPUT.AUTHORIZE_AGREEMENT.AGREEMENT.CONJUNCTION"
              | translate
          }}
          <a stand-alone (click)="showAgreement(AgreementType.BIKE)">
            {{
              "AGREEMENT.INPUT.AUTHORIZE_AGREEMENT.AGREEMENT.OV_FIETS"
                | translate
            }}
          </a>
        </span>
      </div>
    </div>

    <div class="formfield">
      <div class="nes-mb-5">
        <div class="nes-flex nes-items-center">
          <input
            type="checkbox"
            class="nes-h-6 nes-w-6 nes-mr-5"
            name="Name here"
            [formControl]="getControl('authorizedDirectDebit')"
            (click)="onCheckboxClick($event, 'authorizedDirectDebit')"
            indeterminate="false"
            borderless="false"
            id="authorizedDirectDebit"
          />
          <label for="authorizedDirectDebit">
            <nes-text size="lg">
              {{ "AGREEMENT.INPUT.AUTHORIZE_DIRECT_DEBIT.LABEL" | translate }}
            </nes-text>
          </label>
        </div>

        @if (getDirectDebitErrorKey()) {
          <nes-error-message>
            {{ getDirectDebitErrorKey() }}
          </nes-error-message>
        }
      </div>
      <nes-text size="sm">
        {{ "AGREEMENT.INPUT.AUTHORIZE_DIRECT_DEBIT.CONTENT" | translate }}
      </nes-text>
    </div>

    <div class="nes-mb-5">
      <div class="nes-flex nes-items-center">
        <input
          type="checkbox"
          label=""
          class="nes-h-6 nes-w-6 nes-mr-5"
          name="Name here"
          [formControl]="getControl('authorizedVerifyInfo')"
          (click)="onCheckboxClick($event, 'authorizedVerifyInfo')"
          indeterminate="false"
          borderless="false"
          id="authorizedVerifyInfo"
        />
        <label for="authorizedVerifyInfo">
          <nes-text size="lg">
            {{ "AGREEMENT.INPUT.AUTHORIZE_VERIFY_INFO.LABEL" | translate }}
          </nes-text>
        </label>
      </div>

      <div
        textOrKey=""
        *ngIf="
          isTouchedAndDirty('authorizedVerifyInfo') &&
          hasError('authorizedVerifyInfo', 'required')
        "
      >
        <ng-container>
          <nes-error-message>
            {{
              "AGREEMENT.INPUT.AUTHORIZE_VERIFY_INFO.ERROR_REQUIRED" | translate
            }}
          </nes-error-message>
        </ng-container>
      </div>
    </div>
    <nes-text size="sm">
      {{ "AGREEMENT.INPUT.AUTHORIZE_VERIFY_INFO.CONTENT" | translate }}
    </nes-text>
  </section>
  <section class="nes-mb-5">
    <nes-heading class="nes-mb-5" weight="normal" size="6xl">{{
      "AGREEMENT.PAYMENT_INFO_HEADER" | translate
    }}</nes-heading>
    <nes-text class="nes-mb-3" size="lg">
      {{ "AGREEMENT.PAYMENT_INFO_SUBTEXT" | translate }}
    </nes-text>
    <nes-message-inline
      type="informative"
      interactive="false"
      rounded="true"
      border="bottom"
      icon="info-filled"
      class="nes-mb-3"
      [heading]="'AGREEMENT.PAYMENT_INFO_MESSAGE_BAR' | translate"
    >
    </nes-message-inline>
  </section>
  <section>
    <form [formGroup]="formGroup" (ngSubmit)="formSubmit()">
      <section>
        <bca-choose-issuer
          [issuers]="issuers$ | async"
          [selectedIssuerId]="selectedIssuerId$ | async"
          [issuerRequiredError]="getIssuerErrorKey()"
          (selected)="onIssuerSelected($event)"
        >
        </bca-choose-issuer>
      </section>
      <nes-text class="nes-mb-3" size="lg">
        {{ "AGREEMENT.PAYMENT_INFO_AFTER" | translate }}
      </nes-text>
      <div class="actionBar mt-3">
        <div
          *ngIf="startPaymentLoading$ | async; else actionBar"
          class="mt-1 basicLoader"
        ></div>
        <ng-template #actionBar>
          <div
            class="nes-flex nes-w-full nes-justify-between nes-items-center nes-flex-wrap"
          >
            <a
              (click)="previousRoute()"
              [cypress]="'previous_page'"
              class="backArrowLink backArrowLink--compact backArrowLink--button actionBar__item"
            >
              <span class="backArrowLink__text">{{
                "BUTTON.BACK" | translate
              }}</span>
            </a>
          </div>
          <nes-button
            icon-trailing="true"
            type="submit"
            [cypress]="'next_page'"
            variant="brand"
            nes-id="submit"
            (nesOnClick)="formSubmit()"
          >
            <span class="s-hidden m-visible">
              {{ "AGREEMENT.BUTTON.CONFIRM_DESKTOP" | translate }}
            </span>
            <span class="s-visibile m-hidden">
              {{ "AGREEMENT.BUTTON.CONFIRM_MOBILE" | translate }}
            </span>
          </nes-button>
        </ng-template>
      </div>
    </form>
  </section>
</div>
